export var MarketConstants;
(function (MarketConstants) {
    MarketConstants[MarketConstants["ContractCooldownTime"] = 15] = "ContractCooldownTime";
    MarketConstants[MarketConstants["TotalContracts"] = 9] = "TotalContracts";
})(MarketConstants || (MarketConstants = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/MarketConstants.ts
// module id = 418
// module chunks = 3